var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function () {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];

      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;

        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };

        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;

        case 7:
          op = _.ops.pop();

          _.trys.pop();

          continue;

        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }

          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }

          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }

          if (t && _.label < t[2]) {
            _.label = t[2];

            _.ops.push(op);

            break;
          }

          if (t[2]) _.ops.pop();

          _.trys.pop();

          continue;
      }

      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

var __spreadArray = this && this.__spreadArray || function (to, from) {
  for (var i = 0, il = from.length, j = to.length; i < il; i++, j++) to[j] = from[i];

  return to;
};

import { QiniuErrorName, QiniuError } from '../errors';
import * as utils from '../utils';
import { S3Client } from "@aws-sdk/client-s3";
export var DEFAULT_CHUNK_SIZE = 5; // 单位 MB（AWS最小5M）
// code 信息地址 https://developer.qiniu.com/kodo/3928/error-responses

export var FREEZE_CODE_LIST = [0, 502, 503, 504, 599]; // 将会冻结当前 host 的 code
// 408/504 超时

export var RETRY_CODE_LIST = __spreadArray(__spreadArray([], __read(FREEZE_CODE_LIST)), [612, 408, 504]); // 会进行重试的 code

var GB = Math.pow(1024, 3);

var Base =
/** @class */
function () {
  function Base(options, handlers, logger) {
    this.logger = logger;
    this.aborted = false;
    this.retryCount = 0;
    this.xhrList = [];
    this.config = options.config;
    logger.info('config inited.', this.config);
    this.bucketName = this.config.bucketName;
    this.endpoint = this.config.endpoint;
    this.region = this.config.region;
    this.file = options.file;
    this.key = options.key;
    this.token = options.token;
    this.onData = handlers.onData;
    this.onError = handlers.onError;
    this.onComplete = handlers.onComplete;

    try {
      var putPolicy = utils.getPutPolicy(this.token);
      this.assessKey = putPolicy.accessKeyId;
      this.secretAccessKey = putPolicy.secretAccessKey;
      this.token = putPolicy.sessionToken;
      this.s3Client = new S3Client({
        endpoint: "https://" + this.endpoint + "/",
        region: 'us-west-1',
        credentials: {
          accessKeyId: this.assessKey,
          secretAccessKey: this.secretAccessKey,
          sessionToken: this.token
        }
      });
    } catch (error) {
      logger.error('get putPolicy from token failed.', error);
      this.onError(error);
    }
  }
  /**
   * @returns Promise 返回结果与上传最终状态无关，状态信息请通过 [Subscriber] 获取。
   * @description 上传文件，状态信息请通过 [Subscriber] 获取。
   */


  Base.prototype.putFile = function () {
    return __awaiter(this, void 0, void 0, function () {
      var data, err_1, notReachRetryCount, needRetry;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            this.aborted = false;

            if (this.file.size > 100 * GB) {
              this.handleError(new QiniuError(QiniuErrorName.InvalidFile, 'file size exceed maximum value 100G'));
              return [2
              /*return*/
              ];
            }

            _a.label = 1;

          case 1:
            _a.trys.push([1, 3,, 4]);

            this.uploadAt = new Date().getTime();
            return [4
            /*yield*/
            , this.run()];

          case 2:
            _a.sent();

            data = {
              key: this.key,
              location: "https://" + this.bucketName + "." + this.endpoint + "/" + this.key
            };
            this.onComplete(data);
            return [2
            /*return*/
            ];

          case 3:
            err_1 = _a.sent();
            this.logger.error(err_1);
            this.clear();

            if (err_1) {
              notReachRetryCount = ++this.retryCount <= this.config.retryCount;
              needRetry = true; // const needRetry = !this.aborted && RETRY_CODE_LIST.includes(code)
              // 以下条件满足其中之一则会进行重新上传：
              // 1. 满足 needRetry 的条件且 retryCount 不为 0
              // 2. uploadId 无效时在 resume 里会清除本地数据，并且这里触发重新上传

              if (needRetry && notReachRetryCount) {
                this.logger.warn("error auto retry: " + this.retryCount + "/" + this.config.retryCount + ".");
                this.putFile();
                return [2
                /*return*/
                ];
              }
            }

            this.onError(err_1);
            return [3
            /*break*/
            , 4];

          case 4:
            return [2
            /*return*/
            ];
        }
      });
    });
  };

  Base.prototype.stop = function () {
    this.logger.info('stop.');
    this.clear();
    this.aborted = true;
  };

  Base.prototype.addXhr = function (xhr) {
    this.xhrList.push(xhr);
  };

  Base.prototype.getProgressInfoItem = function (loaded, size, fromCache) {
    return __assign({
      size: size,
      loaded: loaded,
      percent: loaded / size * 100
    }, fromCache == null ? {} : {
      fromCache: fromCache
    });
  };

  Base.prototype.handleError = function (error) {
    this.logger.error(error.message);
    this.onError(error);
  }; // fixme 现在没用到xhrList，xhr放在了S3ClientHttpRequestHandler生成


  Base.prototype.clear = function () {
    this.logger.info('start cleaning all xhr.');
    this.xhrList.forEach(function (xhr) {
      xhr.onreadystatechange = null;
      xhr.onload = null;
      xhr.abort();
    });
    this.logger.info('cleanup completed.');
    this.xhrList = [];
  };

  return Base;
}();

export default Base;